import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Active RFID là một dạng truyền thông không dây truyền tải thông tin giữa các thiết bị. Thẻ (tag) Active RFID có nguồn điện riêng, cho phép chúng truyền tín hiệu đi xa. Đây là sản phẩm lý tưởng, đặc biệt để theo dõi các tài sản cần được giám sát theo thời gian thực. Thẻ (tag) Active RFID có thể được đọc ở khoảng cách lên đến vài trăm mét, do đó rất phù hợp cho các giải pháp theo dõi tài sản quy mô lớn.',
  keywords: 'RFID, RTLS, Định vị vị trí, Dinh vi vi tri, Theo dõi vị trí, Theo doi vi tri, Theo dõi trong nhà, Theo doi trong nha',
  ogSite: 'RTLS dựa trên công nghệ Active RFID',
  title: 'RTLS dựa trên công nghệ Active RFID',
  ogUrl: 'https://orbro.io/vi/blog/activerfid',
  ogImg:
    'https://lh3.googleusercontent.com/fife/APg5EOaF0taI55etnk-7VQVh_JecDxbhJX529VYv21nToxYe_qXD-w9k29bChDiW0Dj2JxEgZAtoeKjP5UhTJ0zB6tPZT6tGj5rygnex9J0bJt-k9_HhdDZPSetk87I3E-uDLFHG4xQF9ZgyEozwxxPAL_R0RPL-WNwKtkmGk1-d2GauxlTr2d4hGLWvllQl3_usiu46eWZqw76MEhqjCOs1HfYNn6nZM1_tRdsFDF2YeHeVM_nxLUKocvLFuA1xOhxMMkn2O2EW51rmnrEX66iYcxSgcpQix_5nMEcjBMJRqsrg2ULZuUeQ4R_-ji2u-RIAmKIt45RH7RVpxVW5jORDikiW-LbfzIQeDxdAPu8fq3k5o1IQ15lDVU7_nAae5wo1RxF_2JoYHgTqK1D5f6Zpt9eKA3OZReeim-MmTDklv6WC4CRnzWF1YS6efSa5G_vOTnieHKYY_QQ_w6mQlR-Lzzik_xNgPachPN-w_ls-iM2a-AtLnitE0S5O2xXPUlzsm_NyBM3NaA7BueOWETvdm64Es_4LjIsbnlQ-A_MIMbKZjiL7lIfWXUtNbYkpFryMZzUFeHXV7j72VtEmvkbmnMeGI120Co5kuvlpsFxOfmcuQTgwQPbRgsgFIWBkAnt9vla-Y4F3szREBBYSt44cgGIqknvJEv_7llpLaRXYYL0v1mKTnDRjXVKmGHugaxJNamcxLIHjGAgw_PfhHxMTYYeHs216wRGREOhMRsYnaIoi9httnwkNN911s1nK48m8YaTploLUIbMNoGasxH9yXlqXAcZUvDzbzAw4-bEzD4WBeX0pNQe9TuF3QnV2GlnklwVCLrWL8O4jE6jpOvW7KYMKIdAGPTkpHGBsViFHHX6nWFYHtsfaFKj8hjAUJmLrR_To65RSXQRHqfPye2voD_IDE6XhqnFK5Zi9gcsBgwZo7KQuihZcE_ctUyQOfFYvDJA8NILsJsvoGZQXQjPJvIaYmV9LfETM1MMCSL4AC4Vp4ZqQi7q6Fr1cvv1zrmYChkRYtxC00M5Eo2qg2-Qmb8SiANdUYeHxsSOLl5ybYsXBTbEUI9wY0jvT646VkLtHUf-AR9QdUnMqwj2YROz8lgVDZgZroHzXpzDUJaVt1BieJuuk5OLawO2eOrDN7VRU9i35NYRxx_eMOjeVvXJNJ7QxDISJgoCj_iLnilmShn8QmQfU5zINgqzKac6Ru0cJvScz5k_IQxEx_L9LXfqjaljUjhkI65UDijCW-u328M_DEEGeW9sYavREHwtpdY97oScs7VaBcxyOF2fi6XvP_5Gwig4GyydfN67d_49MmeMMSXVrJajT9i93QKvePas21Tiu8VaLtdSYFnuj_Vy53U1EJihuJXEQG4DoTm_I6UsnaCxf4Ymi0Asp-m2oZlcoywdlRKdj9W8x5uVqd2baDzd4mjNO_CBNMFTMmvGAMOS3XOi3jQYZ0a7tkbrcy1DSNhwv_Ds19DpQrDM5faV6GSaRtRfu-8hgESZSlBC_P3fJ9QPREO5n0TspEozjIrZbHoyhmP7yQB58K-7V3bpk-fKuaw3ruD64ZeIeFyOiJwJDig=w2059-h1216',

  ogType: 'website',
  date: '2023-05-15',
  tag1: '#RFID',
  tag2: '#RTLS',
  tag3: '#Dinhvivitri',
  tag4: '#Theodoivitri #Theodoitrongnha',
  text: [
    {
      head: 'Active RFID là gì?',
      subHead: '',
      desc: 'Active RFID là một dạng truyền thông không dây truyền tải thông tin giữa các thiết bị. Thẻ (tag) Active RFID có nguồn điện riêng, cho phép chúng truyền tín hiệu đi xa. Đây là sản phẩm lý tưởng, đặc biệt để theo dõi các tài sản cần được giám sát theo thời gian thực. Thẻ (tag) Active RFID có thể được đọc ở khoảng cách lên đến vài trăm mét, do đó rất phù hợp cho các giải pháp theo dõi tài sản quy mô lớn.',
      dot: '',
    },
    {
      head: 'So sánh Active RFID và Passive RFID',
      subHead: '',
      desc: 'Thẻ (tag) Active RFID có bộ phát tín hiệu và nguồn điện tích hợp, do đó chúng có thể phát tín hiệu mà không cần đầu đọc bên ngoài. Mặc dù đắt hơn nhiều so với thẻ (tag) Passive RFID, chúng có phạm vi hoạt động rộng hơn. Thẻ (tag) Active thường được sử dụng để theo dõi trong phạm vi rộng, chẳng hạn như trong quản lý kho bãi.\n\nThẻ (tag) Passive RFID không có nguồn điện riêng. Chúng dựa vào năng lượng phát ra từ đầu đọc RFID để kích hoạt và truyền tín hiệu. Do đó, thẻ (tag) Passive RFID rẻ hơn nhiều so với thẻ (tag) Active RFID, nhưng điều này cũng có nghĩa là phạm vi đọc của chúng thường chỉ giới hạn trong vài mét. Thẻ (tag) Passive RFID thường được sử dụng cho các ứng dụng mà phạm vi đọc ngắn là đủ, chẳng hạn như quản lý hàng tồn kho trong bán lẻ.',
      dot: '',
    },
    {
      head: 'Các loại RFID nào được sử dụng hiện nay?',
      subHead: '',
      desc: 'Có hai loại thẻ (tag) Active RFID chính: thẻ (tag) beacon và thẻ (tag) transponder. Thẻ (tag) beacon định kỳ Broadcast (phát quảng bá) thông tin, và các đầu đọc Active RFID trong phạm vi có thể nhận thông tin này. Thẻ (tag) transponder chỉ giao tiếp khi nhận được một truy vấn (query) cụ thể từ đầu đọc Active RFID. Điều này cho phép theo dõi tài sản một cách có mục tiêu hơn, vì mỗi thẻ (tag) chỉ truyền thông tin khi đầu đọc truy vấn (query) thông tin từ nó.',
      dot: '',
    },
    {
      head: 'Có thể kết hợp công nghệ Active RFID với giải pháp RTLS không?',
      subHead: '',
      desc: 'RTLS (Hệ thống Định vị Thời gian Thực) về cơ bản là một loại Active RFID. RTLS hoạt động nhờ các thẻ (tag) Active RFID phát ra tín hiệu mà các bộ thu (receiver) được triển khai khắp cơ sở có thể nhận được. Điều này cho phép theo dõi các tài sản được gắn thẻ (tag) gần như ngay lập tức, cung cấp thông tin giá trị và toàn diện về vị trí của tài sản.',
      dot: '',
    },
    {
      head: 'Ưu điểm của giải pháp RTLS',
      subHead: 'Độ chính xác',
      desc: 'Thẻ (tag) Active RFID thường có thể định vị với độ chính xác cao, lên đến vài centimet. Do đó, Active RTLS rất phù hợp cho các ứng dụng mà thông tin vị trí chính xác là cực kỳ quan trọng, chẳng hạn như trong y tế và sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Dữ liệu thời gian thực',
      desc: 'Hệ thống Active RTLS cung cấp dữ liệu vị trí thời gian thực của các đối tượng được gắn thẻ (tag), cho phép bạn luôn biết tài sản của mình đang ở đâu. Điều này rất hữu ích cho các ứng dụng nhạy cảm về thời gian như bán lẻ và logistics.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Khả năng mở rộng linh hoạt',
      desc: 'Hệ thống Active RTLS có thể được cấu hình để theo dõi mọi loại tài sản, bao gồm con người, pallet và container. Nó có thể theo dõi tài sản ngay cả trong nhà, nơi tín hiệu GPS yếu hoặc không có. Do không yêu cầu tầm nhìn thẳng (line-of-sight) giữa thẻ (tag) và bộ thu, nó rất lý tưởng để theo dõi tài sản trong môi trường có mật độ cao. Những tính năng này làm cho Active RTLS phù hợp với nhiều loại ứng dụng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phạm vi hoạt động',
      desc: 'Thẻ (tag) Active RFID có phạm vi lên đến 100m, lý tưởng để theo dõi các tài sản phân tán trên một khu vực rộng lớn. Khả năng truyền tín hiệu đi xa giúp nó trở nên lý tưởng cho việc theo dõi các tài sản lớn như phương tiện. Thông tin này có thể được sử dụng để cải thiện quản lý tài sản và an ninh, cũng như tự động hóa các tác vụ như quản lý hàng tồn kho.',
      dot: '',
    },
    {
      head: 'Ứng dụng thực tiễn của hệ thống theo dõi tài sản dựa trên Active RTLS',
      subHead: '',
      desc: 'Hệ thống Active RTLS có thể được sử dụng trong nhiều ứng dụng khác nhau như sau.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Y tế',
      desc: 'Hệ thống Active RTLS cho y tế được sử dụng để theo dõi vị trí của bệnh nhân, nhân viên và thiết bị trong bệnh viện. Thông tin này có thể được sử dụng để cải thiện việc quản lý và sự an toàn của bệnh nhân, cũng như quản lý hiệu quả hơn các nguồn lực của bệnh viện.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Sản xuất',
      desc: 'Hệ thống Active RTLS cho sản xuất được sử dụng để theo dõi vị trí của nguyên liệu thô, thành phẩm và thiết bị sản xuất trong nhà máy. Thông tin này có thể giúp cải thiện hiệu quả sản xuất và quản lý chất lượng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Bán lẻ',
      desc: 'Hệ thống Active RTLS được sử dụng để theo dõi vị trí hàng tồn kho trong các cửa hàng bán lẻ. Thông tin này có thể cải thiện dịch vụ khách hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Logistics và kho vận',
      desc: 'Hệ thống Active RTLS được sử dụng để theo dõi vị trí của pallet, container và các tài sản khác trong kho và trung tâm logistics. Thông tin này có thể được sử dụng để cải thiện độ chính xác và hiệu quả của việc giao nhận.',
      dot: '',
    },
    {
      head: '',
      subHead: '',
      desc: 'Xét tính thực tiễn và linh hoạt của hệ thống theo dõi tài sản dựa trên RTLS, có thể xếp đây là một hệ thống hiệu quả về chi phí. Một điểm đáng chú ý nữa là chi phí của các hệ thống RTLS này đã liên tục giảm trong vài năm qua.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],

    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
